/**
 * Área do projeto usa o vocabulário próprio do controle (cargos), não a tabela
 * areas_atuacao das vagas: trocar misturaria os dois e quebraria relatórios.
 */
export const AREAS_DO_PROJETO = [
  "Redação",
  "Direção de Arte / Design",
  "Motion 3D/2D",
  "Ilustração",
  "ACD / DC",
  "Atendimento",
  "Planejamento",
  "Mídia",
  "Produção",
  "Digital: Social Media",
  "Digital: Estrategista",
  "Digital: Conteúdo",
  "Digital: BI",
  "Digital: Marketing de influência",
  "Digital: Perfomance e mídia paga",
  "Digital: UX / UI",
  "Gerente de projetos",
  "Fotografia",
  "Jornalismo",
  "Relações Públicas",
  "Arquitetura",
  "Áudio",
  "Arte Final",
  "Revisor de textos",
  "Consultoria",
];
